import Base from 'app/views/base';

import tmpl from 'templates/pagination_buttons';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .prev_page': 'pageBack',
    'click .next_page': 'pageNext',
  },

  initialize() {
    this.listenTo(this.model, 'updateButtons', this.render);
  },

  context() {
    return {
      disableBack: this.model.onFirstPage(),
      disableNext: this.model.onLastPage(),
    };
  },

  pageBack(e) {
    e.preventDefault();
    this.model.pageBack();
  },

  pageNext(e) {
    e.preventDefault();
    this.model.pageNext();
  },
});



// WEBPACK FOOTER //
// ./app/views/pagination_view.js